/* ============================================================
   NORTHSHEEP — Expected delivery date (TEST feature)
   Fills [data-ns-del-date] with an estimated window using the shared
   ns-delivery-date.js helper: business days only (Mon–Fri), with a
   configurable cut-off time + timezone (orders past the cut-off, or on
   a weekend, slip one working day). Min/max days, locale, cut-off and
   timezone come from the element's data attributes, so each country
   store sets its own expectation. Re-fills when the cart drawer / cart
   page re-renders. Uses "Expected"/estimate language only.
   ============================================================ */
(function () {
  if (window.__nsCartDeliveryLoaded) return;
  window.__nsCartDeliveryLoaded = true;

  // Fallback only — the shared helper (window.NsDelivery) is the real path.
  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay(); // 0 = Sun, 6 = Sat
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  /* Fallback twin of NsDelivery.fmtRange — "Thu 1 – Fri 2 October" (short day
     names, owner 2026-09-28), month printed once unless the window crosses one.
     Kept in step with the product page so the cart drawer and cart page never
     quote the same window in a different shape. */
  function fmtRange(a, b, locale) {
    var loc = (!locale || /^en/i.test(locale)) ? 'en-GB' : locale;
    var wd = { weekday: 'short', day: 'numeric' };
    var mo = { month: 'long' };
    try {
      if (!b || a.getTime() === b.getTime()) return a.toLocaleDateString(loc, wd) + ' ' + a.toLocaleDateString(loc, mo);
      if (a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth()) {
        return a.toLocaleDateString(loc, wd) + ' – ' + b.toLocaleDateString(loc, wd) + ' ' + a.toLocaleDateString(loc, mo);
      }
      return a.toLocaleDateString(loc, wd) + ' ' + a.toLocaleDateString(loc, mo) + ' – ' +
        b.toLocaleDateString(loc, wd) + ' ' + b.toLocaleDateString(loc, mo);
    } catch (e) { return a.toDateString(); }
  }

  function fill() {
    var els = document.querySelectorAll('[data-ns-del-date]:not([data-ns-del-filled])');
    if (!els.length) return;
    var today = new Date();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      if (isNaN(min)) min = 1;
      if (isNaN(max)) max = 3;
      if (max < min) max = min;
      var locale = el.getAttribute('data-locale') || undefined;
      var cutoff = el.getAttribute('data-cutoff');
      var tz = el.getAttribute('data-tz') || 'Europe/Amsterdam';
      var start, end;
      if (window.NsDelivery && window.NsDelivery.fmtRange) {
        var r = window.NsDelivery.computeRange({ min: min, max: max, cutoff: cutoff, tz: tz });
        start = r.start; end = r.end;
        el.textContent = window.NsDelivery.fmtRange(start, min === max ? null : end, locale);
      } else {
        start = addBusinessDays(today, min);
        end = addBusinessDays(today, max);
        el.textContent = fmtRange(start, min === max ? null : end, locale);
      }
      el.setAttribute('data-ns-del-filled', '1');
    }
  }

  function init() {
    fill();
    // Re-fill when the cart drawer / cart page re-renders (new placeholders).
    if ('MutationObserver' in window) {
      var obs = new MutationObserver(function () {
        window.clearTimeout(fill._t);
        fill._t = window.setTimeout(fill, 60);
      });
      ['cart-drawer', '#main-cart-items', '#main-cart-footer'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el) obs.observe(el, { childList: true, subtree: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
